<template>
  <el-popover trigger="click">
    <el-button type="text" size="mini" @click="toJiaoxue" style="float:right;"><i class="el-icon-view"></i>查看更多培训</el-button>
    <div style="clear:both">
      <div v-for="(items, cate) in popData" :key="cate">
        <div class="morandi-text" style="font-size:14px">【{{cate}}】</div>
        <div style="padding:5px 10px">
          <div class="a-link" v-for="(item, k) in items" :key="k" @click="openDia(item)" style="margin-bottom:5px;font-size:12px">{{item.title}}</div>
        </div>
      </div>
    </div>
    <div slot="reference" style="display:flex;cursor:pointer;line-height:16px">
      <div :style="{
        backgroundImage:'url('+require('../../../assets/images/book.png')+')',
        width: '16px', height: '16px', 'background-size': 'cover', 'margin-right': '3px'}"></div>
      <div class="morandi-text" style="font-size:12px">培训教学</div>
    </div>
  </el-popover>
</template>
<script>
import peixunData from './peixunData'
export default {
  props: {
    type: {
      type: String,
      default: '1',
    }
  },
  computed: {
    popData() {
      return peixunData[this.type]
    }
  },
  methods: {
    toJiaoxue() {
      return window.open(`${window.origin}/#/catalogue/培训`, '_blank')
    },
    openDia(item) {
      console.log(item)
      app.root.$refs.PeixunDia.open(item)
    }
  }
}
</script>
